const About = () => {
  return (
    <div className="page-wrapper fade-in">
      <title>About - Pidesk</title>
      <meta name="description" content="Who we are, what we believe in and how the Pidesk team builds digital products." />

      <section className="section bg-secondary text-center">
        <div className="container" style={{ maxWidth: '800px' }}>
          <h1 className="section-title">Our Story</h1>
          <p className="section-subtitle">
            A developer-driven agency focused on innovation, collaboration, and building impactful tech.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container" style={{ maxWidth: '800px' }}>
          <div className="glass" style={{ padding: '48px', borderRadius: '24px', border: '1px solid var(--border-color)' }}>
            <h2 style={{ fontSize: '2rem', marginBottom: '24px' }}>Who We Are</h2>
            <p style={{ color: 'var(--text-secondary)', fontSize: '1.125rem', lineHeight: 1.8, marginBottom: '24px' }}>
              Pidesk started with a simple vision: to bridge the gap between complex business requirements and modern, scalable engineering. As a technology agency and builder platform, we've dedicated ourselves to developing software products, websites, and digital solutions that make a tangible difference.
            </p>
            <p style={{ color: 'var(--text-secondary)', fontSize: '1.125rem', lineHeight: 1.8, marginBottom: '40px' }}>
              We believe that the best products are built by empowered teams. That's why we don't just act as a vendor; we integrate with our clients as technical partners, ensuring that every line of code aligns with their strategic goals.
            </p>

            <h2 style={{ fontSize: '2rem', marginBottom: '24px' }}>The Core Philosophy</h2>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '24px', marginBottom: '40px' }}>
              {[
                { title: 'Quality Over Quantity', desc: 'We take pride in writing elegant, maintainable code that scales.' },
                { title: 'Community Centric', desc: 'Through DCIC, we give back to the developer ecosystem.' },
                { title: 'Continuous Innovation', desc: 'We stay on the bleeding edge of tech so you don\'t have to.' }
              ].map((val, i) => (
                <div key={i} style={{ padding: '24px', borderRadius: '12px', backgroundColor: 'var(--bg-secondary)', border: '1px solid var(--border-color)' }}>
                  <h4 style={{ fontSize: '1.25rem', marginBottom: '8px' }}>{val.title}</h4>
                  <p style={{ color: 'var(--text-secondary)' }}>{val.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
